import React, { useState } from "react";
import axios from "axios";
import { Key, X, Lock } from "lucide-react";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const ChangePasswordModal = ({ isOpen, onClose }) => {
  const [currentPassword, setCurrent] = useState("");
  const [newPassword, setNew] = useState("");
  const [confirmPassword, setConfirm] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword.length < 6) {
      toast.error("A nova senha deve ter no mínimo 6 caracteres.");
      return;
    }
    if (newPassword !== confirmPassword) {
      toast.error("As senhas não conferem.");
      return;
    }
    setSubmitting(true);
    try {
      await axios.post(`${API}/auth/change-password`, {
        current_password: currentPassword,
        new_password: newPassword,
      });
      toast.success("Senha alterada com sucesso!");
      setCurrent(""); setNew(""); setConfirm("");
      onClose();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erro ao trocar senha.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/85 backdrop-blur-md">
      <div
        data-testid="modal-change-password"
        className="w-full max-w-md bg-[#131C2E] border border-[#D4AF37]/40 rounded-2xl shadow-[0_0_50px_rgba(212,175,55,0.25)] overflow-hidden"
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-800 bg-[#080C14]">
          <div className="flex items-center space-x-2">
            <Key className="w-5 h-5 text-[#D4AF37]" />
            <h3 className="font-serif font-bold text-lg text-white">Trocar Senha</h3>
          </div>
          <button
            onClick={onClose}
            data-testid="btn-close-change-password"
            className="p-1.5 rounded-lg text-slate-400 hover:text-white hover:bg-slate-800"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4 text-xs text-slate-300">
          <div>
            <label className="block mb-1 font-semibold text-slate-300">Senha Atual *</label>
            <input
              data-testid="input-current-password"
              type="password"
              required
              value={currentPassword}
              onChange={(e) => setCurrent(e.target.value)}
              placeholder="••••••••"
              className="w-full bg-[#080C14] text-white p-2.5 rounded-xl border border-slate-700 focus:border-[#D4AF37] text-xs font-mono"
            />
          </div>

          <div>
            <label className="block mb-1 font-semibold text-slate-300">Nova Senha (mín. 6 caracteres) *</label>
            <input
              data-testid="input-new-password"
              type="password"
              required
              minLength={6}
              value={newPassword}
              onChange={(e) => setNew(e.target.value)}
              placeholder="••••••••"
              className="w-full bg-[#080C14] text-white p-2.5 rounded-xl border border-slate-700 focus:border-[#D4AF37] text-xs font-mono"
            />
          </div>

          <div>
            <label className="block mb-1 font-semibold text-slate-300">Confirmar Nova Senha *</label>
            <input
              data-testid="input-confirm-password"
              type="password"
              required
              value={confirmPassword}
              onChange={(e) => setConfirm(e.target.value)}
              placeholder="••••••••"
              className="w-full bg-[#080C14] text-white p-2.5 rounded-xl border border-slate-700 focus:border-[#D4AF37] text-xs font-mono"
            />
          </div>

          <div className="pt-4 border-t border-slate-800 flex justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 rounded-xl bg-slate-800 text-slate-300 hover:text-white font-semibold text-xs"
            >
              Cancelar
            </button>
            <button
              data-testid="btn-submit-change-password"
              type="submit"
              disabled={submitting}
              className="bg-[#D4AF37] hover:bg-[#C5A028] text-slate-950 font-bold px-6 py-2 rounded-xl text-xs uppercase tracking-wider shadow-[0_0_15px_rgba(212,175,55,0.3)] flex items-center gap-2 disabled:opacity-50"
            >
              <Lock className="w-3.5 h-3.5" />
              {submitting ? "Salvando..." : "Salvar Nova Senha"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
